import $ from 'jquery';
import _ from 'lodash-es';
import buttonsGetLine from '../Button/buttonsGetLine';

export default (container = document) => {
  $('[data-rte-buttons]', container).each((i, buttons) => {
    const $buttons = $(buttons);

    // weird things happen when you use the same format as shopify...
    const possibly_json = $buttons.find('[data-settings]').html();
    const json = possibly_json.replace('// <![CDATA[', '').replace('// ]]>', '');
    const data = JSON.parse(json);
    const {blocks, settings} = data;   
    let buttons_content = '';
    let buttons_animation = '';
    const section_id = `RteButtons--${i}`;

    if (settings.animation && settings.animation !== 'none') {
      buttons_animation = `Animate Animate--${settings.animation}`;
    }

    _.forEach(blocks, (button) => {

      if (button.button_text) {
        buttons_content += `
        <span class="Button__container ${buttons_animation}">
          <a href="${button.button_url || ''}" class="Button Button--${button.button_style || ''}">
            ${button.button_text}
          </a>
        </span>
        `;
      }
    });

    const buttons_styles = `
      <style>
        .rte #section${section_id} .Section__container {
          padding-top: ${settings.padding_top || 50}px;
          padding-bottom: ${settings.padding_bottom || 50}px;
        }
        @media only screen and (max-width: ${window.theme.settings.grid_mobile_max}) {
          .rte #section${section_id} .Section__container {
            padding-top: ${settings['padding_top--mobile'] || 40}px;
            padding-bottom: ${settings['padding_bottom--mobile'] || 40}px;
          }      
        }
      </style>
    `;
   
    const buttons_section = `
      <section 
        id="section${section_id}" 
        data-section-id="${section_id}" 
        data-section-type="Buttons" 
        class="Section Section--${settings.width || 'fixed'} Section--${settings['width--mobile'] || 'mobile-fixed'}" 
        style="${settings.use_background ? `background: ${settings.background};` : ''}"
      >
        <div class="Section__container">
          ${settings.heading ? `<h3 class="Section__heading">${settings.heading}</h3>` : ''}
          <div class="Buttons">
            ${buttons_content}
          </div>
        </div>
        ${buttons_styles}
      </section>
    `;
    
    $buttons.html(buttons_section);
    buttonsGetLine();
  });
};